// extracted by mini-css-extract-plugin
export default {"teammatesGrid":"teammates_teammatesGrid__DAeYd","teammateCard":"teammates_teammateCard__bB-zF"};